import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../Store';

// Route guard for screens more than one kind of staff shares — the stock room,
// the delivery counter, the topup queue.
//
// Admins always pass. Everyone else needs either one of the named permissions
// or one of the named roles. `roles` exists because some screens are shared by
// job, not by capability: the topup queue belongs to agents and admins alike,
// and AgentRoute alone would bounce an admin, who holds no isAgent flag.
//
// This only decides what the browser will render — every endpoint behind these
// screens re-checks the same thing against the database, so a hand-typed URL
// gains nothing.
export default function StaffRoute({ children, permissions = [], roles = [] }) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  if (!userInfo) return <Navigate to="/signin" />;
  if (userInfo.isAdmin) return children;

  const held = userInfo.permissions || {};
  const byPermission = permissions.some((permission) => held[permission]);
  const byRole = roles.some((role) =>
    role === 'agent'
      ? Boolean(userInfo.isAgent)
      : role === 'manager'
      ? Boolean(userInfo.isUserManager)
      : role === 'productManager'
      ? Boolean(userInfo.isProductManager)
      : false
  );
  return byPermission || byRole ? children : <Navigate to="/signin" />;
}
